import { AnyAction } from 'redux';
import { ConversationFilterEnum } from '~/enums/conversations';
import {
  Conversation,
  ConversationList,
  ConversationFilters,
} from '~/interfaces/conversations';
import * as actionTypes from '~/store/actions/actionTypes';

export interface SetConversationListAction {
  type: typeof actionTypes.CONVERSATION_SET_CONVERSATIONS_LIST;
  payload: ConversationList;
}

export interface SetConversationTotalSizeAction {
  type: typeof actionTypes.CONVERSARTION_SET_TOTAL_SIZE;
  payload: number;
}

export interface SetConversationOpenSelectionAction {
  type: typeof actionTypes.CONVERSARTION_OPEN_SELECTION;
  payload: boolean;
}

export interface SetConversationIsLoadingAction {
  type: typeof actionTypes.CONVERSARTION_ISLOADING;
  payload: boolean;
}

export interface SetConversationHiddenBottomNavAction {
  type: typeof actionTypes.CONVERSARTION_HIDDEN_BOTTOMNAV;
  payload: boolean;
}

export interface SetResetConversationsListAction {
  type: typeof actionTypes.CONVERSATION_RESET_CONVERSATIONS_LIST;
  payload?: null;
}

export interface ResetConversationsAction {
  type: typeof actionTypes.CONVERSATION_RESET;
  payload?: null;
}

export interface SetConversationLastReadIndexAction {
  type: typeof actionTypes.CONVERSATION_SET_LAST_READ_INDEX;
  payload: number;
}

export interface SetConversationPageAction {
  type: typeof actionTypes.CONVERSARTION_SET_PAGE;
  payload: number;
}

export interface SetConversationFiltersAction {
  type: typeof actionTypes.CONVERSARTION_SET_FILTERS;
  payload: ConversationFilters;
}

export interface SetConversationBadgeCountAction {
  type: typeof actionTypes.CONVERSARTION_SET_BADGE_COUNTER;
  payload: number;
}

export interface SetConversationChatAction {
  type: typeof actionTypes.CONVERSATION_SET_ACTIVE_CHAT;
  payload: Conversation | null;
}

type ConversationActions =
  | SetConversationListAction
  | SetConversationTotalSizeAction
  | SetConversationOpenSelectionAction
  | SetConversationIsLoadingAction
  | SetConversationHiddenBottomNavAction
  | SetResetConversationsListAction
  | ResetConversationsAction
  | SetConversationLastReadIndexAction
  | SetConversationPageAction
  | SetConversationFiltersAction
  | SetConversationBadgeCountAction
  | SetConversationChatAction;

interface ConversationState {
  conversations: ConversationList;
  chat: Conversation | null;
  /**
   * Indicates the last read/access or clicked conversation index
   */
  lastReadIndex: number;
  searchFor: string;
  openSelection: boolean;
  hiddenBottomNav: boolean;
  isLoading: boolean;
  totalSize: number;
  filters: ConversationFilters;
  unreadMessagesCount: number;
}

export const initialState: ConversationState = {
  conversations: [],
  chat: null,
  lastReadIndex: 0,
  searchFor: '',
  openSelection: false,
  hiddenBottomNav: false,
  isLoading: false,
  totalSize: 0,
  filters: {
    type: ConversationFilterEnum.MY_MESSAGES,
    is_active: 1,
    page: 1,
    perPage: 10,
  },
  unreadMessagesCount: 0,
};

const reducer = (
  state: ConversationState = initialState,
  action: ConversationActions | AnyAction
): ConversationState => {
  switch (action.type) {
    case actionTypes.CONVERSATION_SET_CONVERSATIONS_LIST:
      return {
        ...state,
        conversations: action.payload,
      };
    case actionTypes.CONVERSATION_SET_ACTIVE_CHAT:
      return {
        ...state,
        chat: action.payload,
      };

    case actionTypes.CONVERSATION_SET_SEARCH_FOR:
      return {
        ...state,
        searchFor: action.payload,
      };
    case actionTypes.CONVERSARTION_OPEN_SELECTION:
      return {
        ...state,
        openSelection: action.payload,
      };
    case actionTypes.CONVERSARTION_HIDDEN_BOTTOMNAV:
      return {
        ...state,
        hiddenBottomNav: action.payload,
      };
    case actionTypes.CONVERSARTION_ISLOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actionTypes.CONVERSARTION_SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
        conversations: [],
        lastReadIndex: 0,
        isLoading: true,
      };
    case actionTypes.CONVERSARTION_SET_BADGE_COUNTER:
      return {
        ...state,
        unreadMessagesCount: action.payload,
      };
    case actionTypes.CONVERSARTION_SET_TOTAL_SIZE:
      return {
        ...state,
        totalSize: action.payload,
      };
    case actionTypes.CONVERSARTION_SET_PAGE:
      return {
        ...state,
        filters: {
          ...state.filters,
          page: action.payload,
        },
      };
    case actionTypes.CONVERSATION_RESET_CONVERSATIONS_LIST:
      return {
        ...state,
        conversations: initialState.conversations,
      };
    case actionTypes.CONVERSATION_SET_LAST_READ_INDEX:
      return {
        ...state,
        lastReadIndex: action.payload,
      };
    case actionTypes.CONVERSATION_RESET:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
